import axios from 'axios';

const API_URL = 'https://api.thebullminer.com';
// const API_URL = 'http://127.0.0.1:8000';

const api = axios.create({
  baseURL: API_URL,
});

// --- INTERCEPTOR DE SEGURIDAD (JWT) ---
// Inyecta el token en la cabecera de cada petición automáticamente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// --- INTERCEPTOR DE EXPIRACIÓN DE SESIÓN (401) ---
// Si el token ya caducó, limpia la sesión vieja y pide iniciar sesión de nuevo
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.config &&
      !error.config.url.includes('/auth/login')
    ) {
      localStorage.removeItem('token');
      localStorage.removeItem('userName');
      localStorage.removeItem('userRole');
      alert('Tu sesión ha expirado por seguridad. Por favor, vuelve a iniciar sesión.');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

// --- ENDPOINTS PÚBLICOS Y DE ALUMNOS ---
export const getCourses = () => api.get('/courses/');
export const getCourseById = (id) => api.get(`/courses/${id}`);
export const loginUser = (credentials) => api.post('/auth/login', credentials);

// --- ENDPOINTS DE FUNDADORES ---
export const setupFounderPassword = (data) => api.post('/founders/setup-password', data);
export const getFounderNotes = (name) => api.get(`/founders/${name}/notes`);
export const createFounderNote = (name, data) => api.post(`/founders/${name}/notes`, data);
export const toggleFounderNote = (noteId, isCompleted) => api.put(`/founders/notes/${noteId}/toggle`, { is_completed: isCompleted });
export const changeFounderPassword = (name, newPassword) => api.put(`/founders/${name}/change-password`, { new_password: newPassword });

// --- ENDPOINTS DE FINANZAS Y AUDITORÍA ---
export const getAuditLogs = () => api.get('/finance/audit');
export const getFinancialRecords = () => api.get('/finance/records');
export const createFinancialRecord = (data) => api.post('/finance/records', data);
export const updateFinancialRecord = (id, notes) => api.put(`/finance/records/${id}`, { notes });

export default api;